import React from 'react'
import { Box, Button } from 'fw/components'
import { Form } from 'fw/forms'
import { DocumentUpload } from 'areas/shared/controls'
import { ContentHeader, ContentBody } from 'areas/shared/components'
import { Col, Row } from 'react-bootstrap'
import * as API from 'modules/app/API'
import * as Notifications from 'fw/globals/Notifications';

class SupplierList extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            form: {
                supplierListStorageToken: null,
                supplierListFileName: null,
            }
        };
    };

    componentDidMount() {
        API.Biz.post('/vobSetup/getSupplierList', null,
            {
                success: (r) => {
                    let form = this.state.form;
                    form.supplierListStorageToken = r.data.supplierListStorageKey;
                    form.supplierListFileName = r.data.supplierListFileName;
                    this.setState({ form });
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                }
            });
    }

    handleUploadChange = (file) => {
        let form = this.state.form;
        form.supplierListStorageToken = file.storageToken;
        form.supplierListFileName = file.fileName;
        this.setState({ form });
    }

    handleUploadRemove = () => {
        let form = this.state.form;
        form.supplierListStorageToken = '';
        form.supplierListFileName = '';
        this.setState({ form });
    }

    save = () => {
        let rq = {
            supplierListStorageKey: this.state.form.supplierListStorageToken,
            supplierListFileName: this.state.form.supplierListFileName
        };

        API.Biz.post('/vobSetup/saveSupplierList', rq,
            {
                success: (r) => {
                    Notifications.success(r.message);
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                }
            });
    }

    render() {
        return (
            <React.Fragment>
                <Form
                    onSubmit={this.onSubmit}
                    values={this.state.form}
                    unsavedChangesWarning={true}
                    ref={(form) => { this._form = form }}>
                    <ContentHeader title='Supplier List'>
                    </ContentHeader>
                    <ContentBody>
                        <Box>
                            <Row>
                                <Col md={10}>
                                    <DocumentUpload
                                        storageToken={this.state.form.supplierListStorageToken}
                                        fileName={this.state.form.supplierListFileName}
                                        onChange={this.handleUploadChange}
                                        onRemove={this.handleUploadRemove} />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Button id='save' bsStyle='primary' className='pull-right' onClick={this.save}>Save</Button>
                                </Col>
                            </Row>
                        </Box>
                    </ContentBody>
                </Form>
            </React.Fragment >
        );
    }
}
export default SupplierList;



// WEBPACK FOOTER //
// ./src/areas/admin/supplierList/SupplierList.js